import { render, staticRenderFns } from "./MonthlyFeesSection.vue?vue&type=template&id=3053866a&scoped=true&"
import script from "./MonthlyFeesSection.vue?vue&type=script&lang=js&"
export * from "./MonthlyFeesSection.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyFeesSection.vue?vue&type=style&index=0&id=3053866a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3053866a",
  null
  
)

export default component.exports